import { RecentOrders } from './RecentOrders';
import { connect } from 'react-redux';
import { default as orderActions } from 'src/store/modules/orders/actions';
import { IOrders } from 'src/model/modules/orders.model';
import {
  ordersIsPendingSel,
  ordersErrorSel,
  ordersRecentSel
} from 'src/store/modules/orders';
import { isLoggedInSel } from 'src/store/modules/signin';
import { withI18n } from 'react-i18next';

interface IStateFromProps {
  isLoggedIn: boolean;
  recentOrders: IOrders[];
  isLoading: boolean;
  hadError: boolean;
}

interface IDispatchFromProps {
  getRecentOrders(): void;
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: isLoggedInSel(state),
  recentOrders: ordersRecentSel(state),
  isLoading: ordersIsPendingSel(state),
  hadError: ordersErrorSel(state).hasFailed
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getRecentOrders: () => dispatch(orderActions.getRecentOrders())
});

export default connect<IStateFromProps, IDispatchFromProps, void>(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(RecentOrders));
